import React from "react";
import Avatar from "../../avatar";

const ClubItemMedium = ({
	name,
	meta,
	photoUrl,
	extra = "",
	dimension = "thumb6",
}: {
	name: string;
	meta: string;
	photoUrl: string;
	extra?: string;
	dimension?: string;
}) => (
	<div className={`item club medium ${extra}`}>
		{photoUrl ? (
			<div className="itemImage">
				<Avatar className="club" photoUrl={photoUrl} size={dimension} />
			</div>
		) : null}
		<div className="itemBody">
			<div className="title">
				<div className="longTextWrap">
					<div className="longText">{name}</div>
				</div>
			</div>
			<div className="meta">
				{meta ? (
					<div className="longTextWrap">
						<div className="longText">{meta}</div>
					</div>
				) : null}
			</div>
		</div>
	</div>
);

export default ClubItemMedium;
